import { render, staticRenderFns } from "./HiringNote.vue?vue&type=template&id=96c79eb0&"
import script from "./HiringNote.vue?vue&type=script&lang=js&"
export * from "./HiringNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports